import { Menu, rem } from "@mantine/core"
import {
  IconAddressBook,
  IconBracketsContain,
  IconContract,
  IconTableOptions,
} from "@tabler/icons-react"

import { NavbarButtonWithMenu } from "@/components/generic/SideNavBar/components/NavbarButtonWithMenu"
import Link from "next/link"

interface NavbarContactsButtonProps {
  isSelected: boolean
  isSidebarMenuExpanded: boolean
}

export function NavbarContactsButton({
  isSelected,
  isSidebarMenuExpanded,
}: NavbarContactsButtonProps) {
  return (
    <NavbarButtonWithMenu
      icon={IconAddressBook}
      isSelected={isSelected}
      isSidebarMenuExpanded={isSidebarMenuExpanded}
    >
      <Menu.Dropdown miw={200}>
        <Menu.Item
          leftSection={
            <IconBracketsContain style={{ width: rem(14), height: rem(14) }} />
          }
          component={Link}
          href={"/contact/properties/library"}
        >
          Contact Properties
        </Menu.Item>
        <Menu.Item
          leftSection={
            <IconTableOptions style={{ width: rem(14), height: rem(14) }} />
          }
          component={Link}
          href={"/contact/lists/library"}
        >
          Contact Lists
        </Menu.Item>
        <Menu.Item
          leftSection={
            <IconContract style={{ width: rem(14), height: rem(14) }} />
          }
          component={Link}
          href={"/contact/bulk/editor"}
        >
          Contacts Bulk Editor
        </Menu.Item>
      </Menu.Dropdown>
    </NavbarButtonWithMenu>
  )
}
